import { AspectRatio, Flex, Heading, Img, Text } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import CollapsibleCard from "./components/CollapsibleCard";
import Button from "ui/components/Button/Button";
import { BsChatDots } from "react-icons/bs";
import localizacao from "assets/images/localizacao.png";
import { useNavigate } from "react-router-dom";
import { BiChevronLeft } from "react-icons/bi";
import OutlineButton from "ui/components/Button/OutlineButton";

export default function Duvidas() {
  const navigate = useNavigate();

  return (
    <Flex
      py={["150px", "150px", "150px", "350px"]}
      px={["50px", "50px", "50px", "200px"]}
      gap="80px"
      flexDir={["column"]}
    >
      <Flex
        gap={10}
        flexDir={["column", "column", "column", "column", "row"]}
        alignItems="center"
      >
        <Flex flexDir="column" gap="6" w={["100%", "100%", "100%", "100%"]}>
          <Heading
            variant="superCellMagic"
            fontWeight="medium"
            fontSize="24px"
            color={colors.purple500}
            flexWrap="wrap"
          >
            DÚVIDAS FREQUENTES
          </Heading>
          <CollapsibleCard
            titleCard="Aniversariantes do mês pagam ingresso?"
            children={
              <Flex>
                Aniversariante do mês tem desconto?
                <br />
                Sim! Aos sábados, aniversariantes do mês têm direito a 50% de
                desconto no ingresso. Para garantir o benefício, é necessário
                fazer a reserva antecipada no site e apresentar um documento
                oficial com foto na portaria do parque no dia da visita.
              </Flex>
            }
          />
          <CollapsibleCard
            titleCard="Comprei pelo site, como retirar o ingresso?"
            children={
              <Flex>
                Simples! Basta apresentar o QRCODE impresso ou no celular na
                entrada do ÁCQUA PARK PANTANAL e passar pelas catracas.
              </Flex>
            }
          />
          <CollapsibleCard
            titleCard="Posso pernoitar no parque?"
            children={
              <Flex mb={4}>
                <Text>
                  Não é possível. No momento o parque está abrindo apenas para
                  day use. Compre o seu ingresso antecipado pelo site:
                  {""}
                  <b
                    style={{
                      color: "#8e95f2",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={() => navigate("/ingresso")}
                  >
                    {" "}
                    Clique Aqui
                  </b>
                </Text>
              </Flex>
            }
          />
          <CollapsibleCard
            titleCard="Posso remarcar o meu ingresso?"
            children={
              <Flex flexDir="column" gap={2}>
                <Text>
                  Ao adquirir o ingresso pelo site, ele ficará disponível na área "Minhas Compras".
                </Text>
                <Text>
                  Caso não compareça na data escolhida, o ingresso poderá ser utilizado em até 30 dias a partir da data da compra, sem necessidade de remarcação.
                </Text>
                <Text>
                  Ingressos de campanhas especiais podem ter prazos de validade diferentes, conforme regulamento divulgado no Instagram.
                </Text>
              </Flex>
            }
          />
          <CollapsibleCard
            titleCard="Quais as formas de pagamento?"
            children={
              <Flex>
                As compras de ingressos antecipados poderão ser realizadas por
                pix ou cartão de crédito em até 3x pelo site ou via WhatsApp.
                Compras de ingressos na portaria do parque podem ser realizadas
                em dinheiro, pix, cartão de débito ou crédito em até 3x. Nas
                demais compras dentro do parque aceitamos; dinheiro, pix,
                crédito a vista e débito.
              </Flex>
            }
          />
          <CollapsibleCard
            titleCard="Quais os dias e horários de funcionamento?"
            children={
              <Flex>
                O parque abre aos sábados e domingos das 09:00 às 17:00
              </Flex>
            }
          />{" "}
          <CollapsibleCard
            titleCard="Qual a localização?"
            children={
              <a
                href="https://goo.gl/maps/2MWKGkyCoyxPXTnv5"
                target={"_blank"}
                rel="noreferrer"
              >
                <AspectRatio ratio={4 / 3}>
                  <Img src={localizacao} />
                </AspectRatio>
              </a>
            }
          />{" "}
          <CollapsibleCard
            titleCard="Qual o valor do ingresso?"
            children={
              <Flex>
                <p>
                  Comprando direto no site ou via WhatsApp do Ácqua Park
                  Pantanal você garante descontos antecipados nas compras entre
                  segunda a sexta-feira.
                </p>
              </Flex>
            }
          />
          <CollapsibleCard
            titleCard="Posso cancelar minha compra?"
            children={
              <Flex flexDir="column" gap={2}>
                <Text>
                  Os ingressos são válidos por até 30 (trinta) dias contados da
                  data da compra. Caso o visitante não compareça na data
                  inicialmente selecionada, o ingresso poderá ser utilizado
                  dentro desse período, sem necessidade de remarcação, observados
                  os dias e horários de funcionamento do parque.
                </Text>
                <Text>
                  Nos termos do art. 49 da Lei nº 8.078/1990 (Código de Defesa
                  do Consumidor), as compras realizadas pelo site poderão ser
                  canceladas no prazo de até 7 (sete) dias contados da data da
                  compra, com direito ao reembolso integral dos valores pagos,
                  desde que nenhum dos ingressos vinculados à compra tenha sido
                  utilizado.
                </Text>
                <Text>
                  Caso o cliente utilize um ou mais ingressos da mesma compra,
                  não será possível o cancelamento parcial nem o reembolso
                  proporcional dos ingressos remanescentes, uma vez que a compra
                  será considerada parcialmente executada. Nessa hipótese, os
                  ingressos ainda não utilizados permanecerão válidos e poderão
                  ser utilizados normalmente até o término do seu prazo de
                  validade.
                </Text>
                <Text>
                  Após o prazo de 7 (sete) dias previsto no art. 49 do Código de
                  Defesa do Consumidor, não será possível solicitar o
                  cancelamento ou o reembolso da compra.
                </Text>
                <Text>
                  Ingressos adquiridos em campanhas promocionais, ações
                  especiais ou condições diferenciadas poderão possuir regras e
                  prazos de validade específicos, conforme regulamento da
                  respectiva campanha.
                </Text>
              </Flex>
            }
          />
          <CollapsibleCard titleCard="Quem tem direito a meia entrada?">
            <Flex>
              <p>
                Idosos, estudantes, jornalistas, jovens de baixa renda e
                doadores de sangue têm direito à meia-entrada, que pode ser
                adquirida pelo site ou na portaria do ÁCQUA PARK PANTANAL. Para
                acessar o parque, é <strong>OBRIGATÓRIA</strong> a apresentação
                do documento comprobatório correspondente na portaria:
                <br />
                <br />• <strong>Idosos:</strong> Documento pessoal com foto ou
                carteirinha.
                <br />• <strong>Estudantes:</strong> Documento pessoal com foto
                + carteirinha de estudante ou atestado de matrícula vigente.
                <br />• <strong>Doadores de sangue e medula óssea:</strong>{" "}
                Documento pessoal com foto + carteirinha de doador frequente
                (mínimo 3 doações de sangue em 12 meses, uma doação de plaquetas
                ou inscrição no banco de doadores voluntários).
                <br />• <strong>Jornalistas:</strong> Carteira funcional dentro
                do prazo de validade.
                <br />• <strong>Jovens de baixa renda:</strong> Documento
                pessoal + carteirinha ID Jovem válida.
                <br />
                <br />A não apresentação do documento pode exigir o pagamento da
                diferença para o valor integral do ingresso.
              </p>
            </Flex>
          </CollapsibleCard>
          <CollapsibleCard titleCard="PCD e TEA pagam ingresso?">
            <Flex direction="column" gap={2}>
              <p>
                <strong>
                  Deficientes e autistas NÃO PAGAM INGRESSO NO ÁCQUA PARK
                  PANTANAL.
                </strong>
              </p>

              <p>
                <strong>
                  DOCUMENTOS ACEITOS PARA GRATUIDADE DE PCDs E AUTISTAS NO
                  PARQUE
                </strong>
              </p>

              <p>
                Para garantir o acesso gratuito ao parque, a pessoa com
                deficiência ou autista deve apresentar um dos seguintes
                documentos:
              </p>

              <p>
                <strong>Documentos principais (válidos):</strong>
                <br />
                • Carteira de identificação de associação ou entidade de
                PCD/autista;
                <br />
                • Carteira emitida pelo CMDPD (Conselho Municipal dos Direitos
                da Pessoa com Deficiência);
                <br />
                • RG com identificação de PCD (RG PCD);
                <br />• CNH com identificação de PCD (CNH PCD).
              </p>

              <p>
                <strong>Caso não possua os documentos acima:</strong>
                <br />• Laudo médico com validade de até 1 ano.
              </p>

              <p>
                <strong>Importante:</strong>
                <br />
                • Se a pessoa com deficiência for maior de 18 anos e precisar de
                acompanhante, essa necessidade deve constar no laudo médico ou
                na carteirinha.
                <br />
                • A gratuidade vale somente para entrada no parque, não inclui
                alimentação ou consumo à parte (como open bar/open food).
                <br />• Se o ingresso estiver vinculado a consumação (ex:
                pulseira com crédito), o acesso ao parque será gratuito, e o
                beneficiário pagará somente o valor da consumação.
              </p>
            </Flex>
          </CollapsibleCard>
          <CollapsibleCard
            titleCard="Posso entrar com alimento e bebidas no parque?"
            children={
              <Flex>
                <p>
                  Não! Inclusive também não é permitido entrar com itens para
                  aniversário como bolos e doces. O parque disponibiliza
                  restaurantes, bares e doceria para a sua comodidade. Além
                  disso, estando com a pulseira é possível entrar e sair do
                  parque quantas vezes for necessário durante o horário de
                  funcionamento.
                </p>{" "}
              </Flex>
            }
          />
          <CollapsibleCard
            titleCard="O que não é permitido nas piscinas do Ácqua Park?"
            children={
              <Flex>
                <p>
                  Usar curativos, faixas, gaze, gesso, absorventes higiênicos,
                  algodão ou pomadas; Usar bronzeadores, sabonetes, copos e
                  utensílios de vidro Realizar brincadeiras que impliquem riscos
                  aos demais frequentadores do Parque; Usar shorts, bermudas,
                  calça jeans, vestidos ou qualquer roupa que possua zíper,
                  botões, ilhós e outros adereços que possam machucar a si ou a
                  terceiros e/ou danificar os equipamentos do parque; Não será
                  permitido qualquer tipo de comportamento discriminatório e/ou
                  indevido que possa ofender a moral e a dignidade dos usuários.
                </p>
              </Flex>
            }
          />
          <CollapsibleCard
            titleCard="Quais os trajes de banhos permitidos?"
            children={
              <Flex>
                <p>
                  O traje de banho masculino será preferencialmente sunga,
                  podendo ainda usar calção com forração interna, tipo tactel. O
                  traje feminino será preferencialmente biquini, maiô ou shorts
                  em malha.
                </p>
              </Flex>
            }
          />
        </Flex>

        <Flex
          bgImage={
            "https://tactonuvem.blob.core.windows.net/imagens/900b34b0-9d5d-4e52-b6ed-80d9c42d8825/site-banners/jacare.png"
          }
          bgRepeat="no-repeat"
          bgSize="cover"
          w={["340px", "350px", "400px", "500px"]}
          height={["320px", "300px", "400px"]}
        />
      </Flex>

      <Flex flexDir="column" gap={4} align="center" textAlign={"center"}>
        <Heading
          variant="superCellMagic"
          fontWeight="medium"
          fontSize="24px"
          color={colors.purple500}
          flexWrap="wrap"
        >
          AINDA TEM DÚVIDAS?
        </Heading>
        <Button
          bg={colors.newBlue}
          onClick={() => navigate("/contato")}
          title="ENTRE EM CONTATO"
          icon={<BsChatDots size={20} />}
        />
      </Flex>
      <OutlineButton
        w={`200px`}
        onClick={() => navigate("/")}
        title="VOLTAR"
        color={colors.newBlue}
        prevIcon={<BiChevronLeft size={20} />}
      />
    </Flex>
  );
}
